import { useQuery } from "convex/react";
import { useMemo } from "react";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { MessageTimeline } from "@/modules/threads/MessageTimeline";
import type { ThreadChild } from "@/modules/threads/types";
import { api } from "../../../convex/_generated/api";

export function LiveThreadMessages({
	clericalThreadId,
}: {
	clericalThreadId: string;
}) {
	const thread = useQuery(api.agent.queries.getThread, { clericalThreadId });

	const childThreadMap = useMemo(() => {
		const map = new Map<string, ThreadChild>();
		if (thread?.children) {
			for (const child of thread.children) {
				map.set(child.clericalThreadId, child);
			}
		}
		return map;
	}, [thread?.children]);

	if (thread === undefined) {
		return (
			<div className="flex h-full items-center justify-center text-sm text-muted-foreground">
				Loading...
			</div>
		);
	}

	if (thread === null) {
		return (
			<div className="flex h-full items-center justify-center text-sm text-muted-foreground">
				Thread not found.
			</div>
		);
	}

	return (
		<div className="flex h-full min-h-0 flex-col">
			<div className="flex shrink-0 items-center gap-2 border-b px-5 py-2">
				<span className="text-sm font-semibold">Messages</span>
				{thread.children.length > 0 && (
					<Badge variant="secondary" className="text-[10px]">
						{thread.children.length} sub-thread
						{thread.children.length !== 1 ? "s" : ""}
					</Badge>
				)}
			</div>
			<ScrollArea className="h-full min-h-0 flex-1">
				<div className="p-4">
					<MessageTimeline
						clericalThreadId={clericalThreadId}
						childThreads={childThreadMap}
					/>
				</div>
			</ScrollArea>
		</div>
	);
}
